/**
 * TanStack Query Keys
 *
 * Hierarchical query keys for cache invalidation and management.
 * Follows TanStack best practices for key factories.
 */

export const queryKeys = {
  root: ['maldevta'] as const,

  licenses: {
    root: ['maldevta', 'licenses'] as const,
    lists: () => [...queryKeys.licenses.root, 'list'] as const,
    detail: (id: number) => [...queryKeys.licenses.root, 'detail', id] as const,
    stats: () => [...queryKeys.licenses.root, 'stats'] as const,
  },

  tenants: {
    root: ['maldevta', 'tenants'] as const,
    lists: () => [...queryKeys.tenants.root, 'list'] as const,
    detail: (id: number) => [...queryKeys.tenants.root, 'detail', id] as const,
    stats: () => [...queryKeys.tenants.root, 'stats'] as const,
  },

  extensions: {
    root: ['maldevta', 'extensions'] as const,
    lists: () => [...queryKeys.extensions.root, 'list'] as const,
    detail: (id: number) => [...queryKeys.extensions.root, 'detail', id] as const,
    pending: () => [...queryKeys.extensions.root, 'pending'] as const,
  },

  billing: {
    root: ['maldevta', 'billing'] as const,
    invoices: () => [...queryKeys.billing.root, 'invoices'] as const,
    detail: (id: number) => [...queryKeys.billing.root, 'invoice', id] as const,
    revenue: () => [...queryKeys.billing.root, 'revenue'] as const,
    revenueStats: () => [...queryKeys.billing.root, 'revenueStats'] as const,
    share: () => [...queryKeys.billing.root, 'share'] as const,
    shares: () => [...queryKeys.billing.root, 'shares'] as const,
  },
} as const

/**
 * Helper to invalidate all queries for a feature
 *
 * @example
 * invalidateQueries(queryClient, 'licenses')
 */
export function invalidateQueries(
  queryClient: any,
  feature: 'licenses' | 'tenants' | 'extensions' | 'billing',
) {
  queryClient.invalidateQueries({
    queryKey: queryKeys[feature].root,
  })
}

/**
 * Helper to invalidate specific query type
 */
export function invalidateQuery(
  queryClient: any,
  queryKey: readonly unknown[] | readonly string[],
) {
  queryClient.invalidateQueries({
    queryKey: queryKey as unknown[] | string[],
  })
}
